import { render, staticRenderFns } from "./NestedPie.vue?vue&type=template&id=5b8b65ec&"
import script from "./NestedPie.vue?vue&type=script&lang=js&"
export * from "./NestedPie.vue?vue&type=script&lang=js&"
import style0 from "./NestedPie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports